{
  "account-not-existed-dialog": {
    "buttons": {
      "cancel": "Cancel",
      "sign-up": "Sign up"
    },
    "text": {
      "hint": "If your are new to us, please create your account first!",
      "not-found-account-with-email": "There is no account with this email {{ email }}",
      "not-found-account-with-phone-nr": "There is no account with this phone number {{ phoneNr }}",
      "title": "Account does not exist"
    }
  }
}
